import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Stack,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material'

const DuplicatedCustomerModalContent = ({ customers, onSelectCustomer }) => {
  return (
    <Stack>
      <Typography variant="body1">
        {`A customer with the same name has already been created.
        Do you want to continue adding this customer or use an existing customer?`}
      </Typography>
      <Box flexGrow={1} mt={1} sx={{ maxHeight: 200, overflow: 'auto' }}>
        {customers?.length > 0 ? (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Existing Customer</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Address</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>License #</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customers.map(customer => (
                  <TableRow key={customer.id}>
                    <TableCell>{customer.displayName || ''}</TableCell>
                    <TableCell>
                      {customer.contacts && customer.contacts[0]
                        ? [customer.contacts[0].address1, customer.contacts[0].address2].filter(Boolean).join(', ')
                        : ''}
                    </TableCell>
                    <TableCell>
                      {customer.contacts && customer.contacts[0] ? customer.contacts[0].licenseNumber || '' : ''}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="outlined"
                        color="success"
                        size="small"
                        sx={{
                          minWidth: 'unset',
                        }}
                        onClick={() =>
                          onSelectCustomer({
                            id: customer.id,
                            customerCommonIdentifierString: customer.displayName,
                          })
                        }
                      >
                        SELECT
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="body2" sx={{ fontStyle: 'italic', textAlign: 'center', py: 2 }}>
            No supplier customers found with this name.
          </Typography>
        )}
      </Box>
    </Stack>
  )
}

DuplicatedCustomerModalContent.propTypes = {
  customers: PropTypes.array,
  onSelectCustomer: PropTypes.func,
}

DuplicatedCustomerModalContent.defaultProps = {
  customers: [],
  onSelectCustomer: () => {},
}

export default DuplicatedCustomerModalContent
